import { CloudOff, RefreshCw, WifiOff, X } from "lucide-react";

import type { PwaStatusSnapshot } from "./types";
import "./PwaStatusNotice.css";

export interface PwaStatusNoticeProps {
  status: PwaStatusSnapshot;
  onDismissCacheFailure(): void;
}

export function PwaStatusNotice({
  status,
  onDismissCacheFailure
}: PwaStatusNoticeProps) {
  if (status.cacheFailureMessage !== null) {
    return (
      <div className="pwa-status-notice pwa-status-notice--warning" role="alert">
        <CloudOff aria-hidden="true" className="pwa-status-notice__icon" />
        <p className="pwa-status-notice__message">{status.cacheFailureMessage}</p>
        <button
          aria-label="关闭提示"
          className="pwa-status-notice__icon-button"
          onClick={onDismissCacheFailure}
          title="关闭提示"
          type="button"
        >
          <X aria-hidden="true" />
        </button>
      </div>
    );
  }

  if (
    status.isApplyingUpdate ||
    (status.isUpdateAvailable && status.isUpdateSafe)
  ) {
    return (
      <div className="pwa-status-notice pwa-status-notice--update" role="status">
        <RefreshCw aria-hidden="true" className="pwa-status-notice__icon" />
        <p className="pwa-status-notice__message">新内容准备好了，正在安全更新。</p>
      </div>
    );
  }

  if (!status.isOnline) {
    return (
      <div className="pwa-status-notice pwa-status-notice--offline" role="status">
        <WifiOff aria-hidden="true" className="pwa-status-notice__icon" />
        <p className="pwa-status-notice__message">
          网络断开了，已经准备好的内容还能继续玩。
        </p>
      </div>
    );
  }

  return null;
}
